import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Modal, Btn } from "@/components/client/ui";

const end = (p) => (p || "").replace(/\D/g, "").slice(-4);

const Choice = ({ testid, title, sub, onClick, warn }) => (
  <button data-testid={testid} onClick={onClick}
    className={`w-full rounded-xl border p-3 text-left text-sm transition-colors ${warn ? "border-amber-500/40 hover:bg-amber-500/10" : "border-[#25D366]/50 hover:bg-[#25D366]/10"}`}>
    <div className="font-semibold text-slate-100">{title}</div>
    <div className={`text-xs ${warn ? "text-amber-300" : "text-slate-400"}`}>{sub}</div>
  </button>
);

export const WaBillingButton = ({ s, disabled, setBusy, onSent }) => {
  const [pick, setPick] = useState(false);
  const c = s.client;
  const chatEnd = end(s.phone);
  const send = async (toChat) => {
    setPick(false);
    setBusy(true);
    try {
      const { data } = await api.post(`/clients/${s.client_id}/remind`, { channel: "whatsapp", session_id: s.id, to_chat: toChat });
      const r = data.results?.[0];
      if (r?.status === "sent") toast.success(`Cobrança enviada no WhatsApp terminado em ${end(r.to)}`);
      else toast.warning(r?.error || "Envio ignorado");
      onSent();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao enviar cobrança"); }
    setBusy(false);
  };
  const click = () => {
    if (c.wa_end && (c.wa_same || !chatEnd)) {
      if (window.confirm(`Enviar a cobrança com o link PIX de ${c.name} para o WhatsApp da ficha (final ${c.wa_end})?`)) send(false);
    } else setPick(true);
  };
  return (
    <>
      <button data-testid="chat-send-wa-billing" onClick={click} disabled={disabled || (!c.wa_end && !chatEnd)}
        className="inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-[#25D366] px-3 py-2 text-xs font-bold text-slate-950 transition-opacity hover:opacity-90 disabled:opacity-50">
        <MessageCircle className="h-3.5 w-3.5" /> Cobrar pelo WhatsApp
      </button>
      {pick && (
        <Modal testid="chat-wa-billing-dialog" title="Para qual WhatsApp?" onClose={() => setPick(false)}>
          <p className="mb-3 text-xs text-slate-400">O número desta conversa é diferente do WhatsApp da ficha de {c.name}.</p>
          <div className="space-y-2">
            {c.wa_end
              ? <Choice testid="chat-wa-billing-client" title={`WhatsApp da ficha (final ${c.wa_end})`} sub="Dono da conta — recomendado" onClick={() => send(false)} />
              : <div className="rounded-xl border border-[#1F293D] p-3 text-xs text-slate-500">A ficha não tem WhatsApp cadastrado.</div>}
            {chatEnd && <Choice testid="chat-wa-billing-chat" warn title={`Número desta conversa (final ${chatEnd})`}
              sub="Pode ser um parente ajudando. Confirme que a pessoa pode receber o PIX deste cliente."
              onClick={() => window.confirm(`Confirma o envio da cobrança de ${c.name} para o número final ${chatEnd}, que não é o da ficha?`) && send(true)} />}
          </div>
          <div className="mt-4 flex justify-end"><Btn tone="ghost" onClick={() => setPick(false)}>Cancelar</Btn></div>
        </Modal>
      )}
    </>
  );
};
